const STORAGE_KEY = "qianchuanViolationScope";

function normalizeScopeValue(value) {
  if (value === null || value === undefined) {
    return undefined;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) {
      return undefined;
    }
    return /^\d+$/.test(trimmed) ? Number(trimmed) : trimmed;
  }
  return value;
}

function getStorage(customStorage) {
  if (customStorage) {
    return customStorage;
  }
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  return null;
}

function readStoredViolationScope(customStorage) {
  const storage = getStorage(customStorage);
  if (!storage) {
    return {
      agentId: undefined,
      groupId: undefined,
    };
  }
  try {
    const rawValue = storage.getItem(STORAGE_KEY);
    if (!rawValue) {
      return {
        agentId: undefined,
        groupId: undefined,
      };
    }
    const parsed = JSON.parse(rawValue);
    return {
      agentId: normalizeScopeValue(parsed.agentId),
      groupId: normalizeScopeValue(parsed.groupId),
    };
  } catch (error) {
    return {
      agentId: undefined,
      groupId: undefined,
    };
  }
}

function writeStoredViolationScope(scope, customStorage) {
  const storage = getStorage(customStorage);
  if (!storage) {
    return;
  }
  const nextScope = {
    agentId: normalizeScopeValue(scope && scope.agentId),
    groupId: normalizeScopeValue(scope && scope.groupId),
  };
  if (!nextScope.agentId && !nextScope.groupId) {
    storage.removeItem(STORAGE_KEY);
    return;
  }
  storage.setItem(STORAGE_KEY, JSON.stringify(nextScope));
}

function clearStoredViolationScope(customStorage) {
  const storage = getStorage(customStorage);
  if (!storage) {
    return;
  }
  storage.removeItem(STORAGE_KEY);
}

function resolveViolationScope(adminInfo, formScope, options) {
  const config = options || {};
  const isManager = Number(adminInfo && adminInfo.type) === 1;
  const currentScope = {
    agentId: normalizeScopeValue(formScope && formScope.agentId),
    groupId: normalizeScopeValue(formScope && formScope.groupId),
  };
  const storedScope = readStoredViolationScope(config.storage);

  if (
    config.allowStoredAgentId &&
    !currentScope.agentId &&
    storedScope.agentId
  ) {
    currentScope.agentId = storedScope.agentId;
    if (!currentScope.groupId && storedScope.groupId) {
      currentScope.groupId = storedScope.groupId;
    }
  }

  const requestData = {};
  if (currentScope.agentId !== undefined) {
    requestData.agentId = currentScope.agentId;
  }
  if (currentScope.groupId !== undefined) {
    requestData.groupId = currentScope.groupId;
  }

  return {
    isManager,
    ready: true,
    requestData,
    scope: currentScope,
  };
}

module.exports = {
  readStoredViolationScope,
  writeStoredViolationScope,
  clearStoredViolationScope,
  resolveViolationScope,
};
